var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"used-badge",class:{
  'is-not-used': _vm.isExpired || (_vm.usedTime === _vm.limitTime),
  'is-small': _vm.isSmall,
  'is-outlined': _vm.isOutlined
}},[(_vm.isExpired && _vm.usedTime < _vm.limitTime)?_c('span',{staticClass:"has-text-centered is-full-width"},[_vm._v(_vm._s(_vm.$t('common.expired')))]):_c('span',{staticClass:"has-text-centered is-full-width"},[_vm._v(_vm._s(_vm.$t('common.used'))+" "+_vm._s(_vm._f("formatNumber")(_vm.usedTime))+" / "+_vm._s(_vm._f("formatNumber")(_vm.limitTime)))])])}
var staticRenderFns = []

export { render, staticRenderFns }